'use strict';
import 'jquery';
import 'jquery.cookie';
import 'cookie-notice-js/dist/cookie.notice'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.pl';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.en-GB';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.ru';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.css';
import 'bootstrap/dist/js/bootstrap';
import 'font-awesome/css/font-awesome.css'
import 'bxslider';
import './utils/fileinput';
import AlertsHelper from "./utils/alerts-helper";
import LanguageSwitcher from "./utils/language-switcher";
import 'simplelightbox';
import 'simplelightbox/dist/simplelightbox.scss';

const alertHandler = new AlertsHelper();
alertHandler.setUpListeners();
alertHandler.delayAlerts();

$(document).ready(function () {

    if ($(window).width() < 767) {
        $('.kafle .desktop-version').remove();
    } else {
        $('.kafle .mobile-version').remove();
    }
    if ($('.extension_of_the_guarantee .kafle')) {
        setTimeout(function () {
            if (!$('#two_year_guarantee').hasClass('active_checkbox')) {
                $('#two_year_guarantee').addClass('active_checkbox');
            }
        }, 100);
    }

    $('.lightbox_view').simpleLightbox(
        {
            showCounter: false

        }
    );
    $('.lightbox_view2').simpleLightbox(
        {
            showCounter: false
        }
    );
    if ($(window).width() < 991) {
        $('.nav-link').click(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).find('.child-wrapper').removeClass('show_sub_menu');
            } else {
                if ($(this).find('div').hasClass('child-wrapper')) {
                    let navLink = $('.nav-link');
                    navLink.removeClass('active');
                    navLink.find('.child-wrapper').removeClass('show_sub_menu');
                    $(this).addClass('active');
                    $(this).find('.child-wrapper').addClass('show_sub_menu').width($(window).width() + 5);
                }
            }
        });
        $(window).resize(function () {
            $('.child-wrapper').width($(window).width() + 5);
        });
    } else {
        $('.nav-link').click(function () {
            if ($(this).find('div').hasClass('child-wrapper')) {
                let navLink = $('.nav-link');
                navLink.removeClass('active');
                navLink.find('.child-wrapper').removeClass('show_sub_menu');
                $(this).addClass('active');
                $(this).find('.child-wrapper').addClass('show_sub_menu');
            }
        });
    }
    $('.language-btn').click(function () {
        $(this).find('#language-switcher').toggleClass('open');
    });
    $('.nav-link .child-wrapper').hover(function () {
        }, function () {
            $(this).closest('.nav-link').removeClass('active');
            $(this).removeClass('show_sub_menu');
        }
    );
    $('.accordion .card button').click(function () {
        if ($(this).closest('.card').hasClass('accordion_shadow')) {
            $('.card').removeClass('accordion_shadow');
        } else {
            $(this).closest('.card').addClass('accordion_shadow');
        }
    });

    (new LanguageSwitcher()).initialize();
    var theLanguage = $('html').attr('lang');

    $(".datepicker").datepicker({
        language: theLanguage,
    });

    $(".datepicker-from-today").datepicker({
        language: theLanguage,
        startDate: new Date()
    });

    $(".datepicker-to-today").datepicker({
        language: theLanguage,
        endDate: new Date()
    });

    $('.filtr .cechy .dropdown-menu svg').click(function () {
        $(this).closest('.col-12').find('label').click();
    });
    $('.filtr .cechy .dropdown-menu label').click(function () {
        if ($(this).closest('.col-12').find('svg').hasClass('active')) {
            $(this).closest('.col-12').find('svg').removeClass('active');
        } else {
            $(this).closest('.col-12').find('svg').addClass('active');
        }
    });
    $('.filtr .cechy .dropdown-menu .row').each(function () {
        if ($(this).find('input[type="checkbox"]').prop('checked')) {
            $(this).find('svg').addClass('active');
        }
    });
    $('.btn_for_comparison svg').click(function () {
        $('#comparison-button').click();
    });
    $('.novalidate .wrap_white_box .form-group').each(function () {
        let placeholder = $(this).find('.placeholder_for_input').text();
        $(this).find('input').attr('placeholder', placeholder);
    });
    if ($(window).width() < 767) {
        $('.first_elem_of_news').removeClass('first_elem_of_news');
    }
    $('textarea').closest('.form-group').find('label').addClass('textarea_block');
})
    .ajaxComplete((_, response) => {
        alertHandler.handleAjaxEvent(response);
    });



// WEBPACK FOOTER //
// ./assets/js/layout.js